export default {
  general: {
    add: 'Add',
    all: 'All',
    close: 'Close',
    dateFormat: 'DD/MM/YYYY',
    apiDateFormat: 'YYYY-MM-DD',
    error: 'An error occurred',
    from: 'from',
    help: 'Help',
    inactiveUser: 'This User is not active. Please ask an administrator to activate it',
    logoutOk: 'Logout completed successfully',
    months: 'months',
    more: 'More',
    next: 'Next',
    no: 'No',
    ok: 'Ok',
    campaignNotFound: {
      text: 'Requested campaign has not been found.',
      link: 'Click here to go to return to the list'
    },
    pageNotFound: {
      text: 'Requested page has not been found.',
      link: 'Click here to go to the home'
    },
    sectionNotFound: {
      text: 'Requested section has not been found.',
      link: 'Click here to go to the first section'
    },
    previous: 'Previous',
    success: 'Operation completed successfully',
    to: 'to',
    warning: 'warning',
    yes: 'Yes'
  },
  message: {
    activate: 'Campaign has been activated',
    create: 'Save completed',
    delete: 'Delete completed',
    forbiddenActivation: 'Cannot create Data Extension from the current Business Unit',
    update: 'Update completed'
  },
  wizard: {
    step: {
      completed: 'Completed'
    }
  },
  action: {
    activate: 'Activate',
    applyFilters: 'Apply filters',
    back: '< Back',
    cancel: 'Cancel',
    clear: 'Clear',
    dismiss: 'Dismiss',
    downloadAsCsv: 'Download as CSV',
    delete: 'Delete',
    edit: 'Edit',
    filter: 'Type to filter',
    next: 'Next >',
    new: 'New',
    openDataExtension: 'Open Data Extension',
    preview: 'Preview',
    publish: 'Publish',
    remove: 'Remove',
    save: 'Save',
    saveDraft: 'Save Draft',
    upload: 'Upload File'
  },
  picklist: {
    values: '-- Select value -- | 1 value selected | {count} values selected'
  },
  campaignDesigner: {
    campaignsList: {
      campaignName: 'Campaign Name',
      campaignType: 'Campaign Type',
      createdDate: 'Created Date',
      createdBy: 'Created By',
      ddsChildCampaign: 'DDS Child',
      ddsParentCampaign: 'DDS Parent',
      deleteCampaign: 'Delete Campaign',
      deleteCampaignConfirm: 'Are you sure you want to delete this campaign?',
      endDate: 'End Date',
      fullCampaign: 'Full Campaign',
      headerCampaign: 'Only Campaign Header',
      id: 'Id',
      newCampaign: 'New Campaign',
      selectCampaignType: 'Select a Campaign Type',
      filters: 'Filters',
      salesCampaign: 'Only Campaign Header Sales',
      salesFullCampaign: 'Full Campaign Sales',
      startDate: 'Start Date',
      status: {
        label: 'Status',
        Active: 'Active',
        Completed: 'Completed',
        Draft: 'Draft',
        Inactive: 'Inactive',
        'In Progress': 'In Progress'
      },
      type: {
        label: 'Campaign Type',
        'Commercial Campaign': 'Commercial Campaign',
        'Contact Plan': 'Contact Plan',
        VHR: 'VHR'
      },
      tag: {
        label: 'Tag',
        Automotive: 'Automotive',
        VHR: 'VHR',
        Welcome: 'Welcome'
      },
      technicalCampaign: 'Technical',
      vhrCampaign: 'VHR'
    },
    campaignSetup: {
      processtype: {
        label: 'Process Type',
        'self': 'Self',
        'assisted': 'Assisted',
        'ccdb_only': 'CCDB Only',
        'phone_lead': 'Phone Lead',
        'lead_shopper': 'Lead Shopper',
        'lead_feedback': 'Lead Feedback'
      },
      maintarget: {
        label: 'Main Target',
        'all': 'All',
        'b2c': 'B2C',
        'b2b': 'B2B'
      },
      campaigncategory: {
        label: 'Campaign Category',
        'L': 'Local',
        'LC': 'Local Collaborative',
        'N': 'National',
        'NC': 'National Collaborative',
      },
      businesstype: {
        label: 'Business Type',
        'aftersales': 'Aftersales',
        'autonomy': 'Autonomy',
        'camper': 'Camper',
        'finance': 'Finance',
        'fleet_business_aftersales': 'Fleet Business Aftersales',
        'fleet_business_sales': 'Fleet Business Sales',
        'heritage': 'Heritage',
        'rental': 'Rental',
        'sales_new': 'Sales New',
        'vcg': 'VCG',
        'sales_used': 'Sales Used',
        'connected_services': 'Connected Services',
        'insurance': 'Insurance',
        'free2move': 'Free2move'
      },
      email_list_tooltip: 'Select SFMC Emails',
      push_list_tooltip: 'Select SFMC Push assets',
      sms_list_tooltip: 'Select SFMC SMS assets',
      sms_list: 'SMS list',
      push_list: 'Push list',
      utm_list: 'Email list',
      namecomputed: 'Campaign Name',
      sellingOnline: {
        label: 'Selling Online',
        'yes': 'Yes',
        'no': 'No',
        'both': 'Both'
      },
      push: 'Push',
      email : 'Email',
      sms: 'SMS',
      BusinessArea: {
        label: 'Business Area',
        "AFTER_SALES" : 'Aftersales',
        "SALES" : 'Sales',
      },
      utm_source: 'UTM Source',
      utm_medium: 'UTM Medium',
      utm_campaign: 'UTM Campaign',
      utm_content: 'UTM Content',
      brandCategory: {
        label: 'Brand Category',
        "1" : 'ExP',
        "2" : 'ExP and ExF'
      },
      acceptanceExpiringDate: 'Acceptance Expiring Date',
      alwaysOn: {
        label: 'Always On',
        'one_time': 'One Time',
        'permanent': 'Permanent',
        tooltip: 'This flag controls daily target recalculation and orchestration (if enabled) for the whole campaign duration'
      },
      brand: 'Brand',
      brands: 'Brands',
      brandsAndModels: 'Brands and models selection',
      callTinyUrl: 'Call Tiny URL',
      campaignPullPush: {
        label: 'Campaign Pull / Push',
        1: 'Centrale',
        2: 'Centrale adesione dealer',
        3: 'Dealer'
      },
      camperContribution: 'Camper Contribution',
      contactCenter: 'Push',
      ccExtractionDaysFreq: 'CC Extraction Days Frequency',
      ccCallsStartDate: 'CC Calls Start Date',
      ccCallsEndDate: 'CC Calls End Date',
      ccMaxRecordsToExtract: 'CC Max Records to Extract',
      ccdbReportEnabled: 'CCDB Report Enabled',
      ccdbReportEnabledTooltip: {
        dds: {
          child: 'Flag the checkbox if in the Content Selection step you will set "FCA" as Template Type (only for DEM and DM)',
          parent: 'Flag the checkbox if in the Content Selection step of the Child campaign you will set "FCA" as Template Type (only for DEM and DM)'
        }
      },
      ccdbReportType: {
        label: 'CCDB Report Type',
        congratulations: 'Congratulations',
        standard: 'Standard'
      },
      ccScript: {
        label: 'CC Script',
        0: 'Do not send DEM',
        1: 'Send DEM'
      },
      channels: {
        label: 'Channels'
      },
      codpack: 'Codpack',
      contentClassification: {
        label: 'Content Classification',
        All: 'All',
        MVP: 'MVP',
        Other: 'Other'
      },
      contributionType: {
        label: 'Contribution Type',
        Standard: 'Standard',
        Fleet: 'Fleet'
      },
      cscEngagementLevel: {
        label: 'Push List',
        Followup: 'Follow-up',
        PrimoContatto: 'First Contact'
      },
      dealerCustomContacts: 'Dealer Custom Contacts',
      demOffer: 'DEM Offer',
      demTinyUrl: 'DEM Tiny URL',
      demTinyUrl1: 'DEM Tiny URL 1',
      demTinyUrl2: 'DEM Tiny URL 2',
      demTinyUrl3: 'DEM Tiny URL 3',
      demTinyUrl4: 'DEM Tiny URL 4',
      demTinyUrl5: 'DEM Tiny URL 5',
      description: 'Description',
      dmOffer: 'DM Offer',
      dmQRCode: 'DM QR Code',
      dmTinyUrl: 'DM Tiny Url',
      endDate: 'End Date',
      externalList: 'External List',
      parent: 'Parent',
      flagProvider: 'Flag Provider',
      fleetWarning: {
        title: 'Fleet',
        text: 'A Fleet campaign type has been selected. Remember to check deduplication settings'
      },
      finality: {
        label: 'Finality',
        'sales' : 'Sales',
        'feedback' : 'Feedback',
        'caring' : 'Caring',
        'awareness' : 'Awareness',
        'nurturing' : 'Nurturing',
        'serviceactivity' : 'Service Activity',
        'winback' : 'Win-back',
        'aftersales' : 'Aftersales',
        'newsletter' : 'Newsletter',
        tooltip: {
          afterSales: 'Use "Service Activity" to include the campaign in contribution evaluation',
          sales: 'Use "Sales New", "Nurturing Lead" and "Win-back Indecisi SF" to include the campaign in contribution evaluation'
        }
      },
      hierarchical: 'Hierarchical',
      htmlDescription: 'HTML Description',
      htmlDescriptionPreview: 'HTML Description Preview',
      imagePreviewUrl: 'Image Preview URL',
      jeepWave: 'Jeep Wave',
      manager: {
        label: 'Manager',
        dealer_fleet: 'Dealer Fleet',
        hq_fleet: 'HQ Fleet',
        HQ: 'HQ',
        Dealer: 'Dealer'
      },
      market: 'Market',
      masterKey: 'Campaign Masterkey',
      mediaCampaignId: 'Media Campaign ID',
      model: 'Model Code',
      modelCps: 'Model CPS',
      modelDescription: 'Model Description',
      name: 'Campaign Label',
      paper: 'Paper',
      plannedSendDateDem: 'Planned Send Date DEM',
      plannedSendDateSMS: 'Planned Send Date SMS',
      ppExtractionDaysFreq: 'PP Extraction Days Frequency',
      ppExtractionEndDate: 'PP Extraction End Date',
      ppExtractionStartDate: 'PP Extraction Start Date',
      ppMaxRecordsToExtract: 'PP Max Records to Extract',
      ppProviderId: 'PP Provider ID',
      ppTemplateFilename: 'PP Template Filename',
      ppUrl1: 'PP Url 1',
      ppUrl2: 'PP Url 2',
      ppUrl3: 'PP Url 3',
      providerElt: 'Provider ELT',
      relevantRedemption: 'Relevant Redemption',
      score: 'Score',
      seed: 'Seed',
      segmentType: {
        label: 'Segment Type',
        'HOT_LEAD': 'HOT LEAD',
        'PERMISSION': 'PERMISSION',
        'CUSTOMER': 'CUSTOMER',
        'PROSPECT': 'PROSPECT',
        'UNDECIDED_SHOPPER': 'UNDECIDED SHOPPER',
        'COLD_LEAD': 'COLD LEAD',
        'OPPORTUNITY': 'OPPORTUNITY',
        'INDECISI_SF': 'INDECISI SF',
        'PREVENTIVI': 'PREVENTIVI',
        'LEAD_LESSEQUAL6_MONTHS': 'LEAD <=6 MONTHS',
        'LEAD_GREATER6_MONTHS': 'LEAD > 6 MONTHS',
        'AS_CUSTOMER_DI_OFFICINA': 'AFTER SALES: CUSTOMER DI OFFICINA',
        'AS_CUSTOMER_FROM_CCF': 'AFTER SALES: CUSTOMER FROM CCF',
        'AS_PROSPECT_GEOGRAFICO': 'AFTER SALES: PROSPECT GEOGRAFICO',
        'AS_MOC_REGISTRATION': 'AFTER SALES: MOC REGISTRATION',
        'HANDRAISER' : 'HANDRAISER',
        'ENTHUSIAST' : 'ENTHUSIAST'
      },
      legalBase: {
        label: 'Legal Base',
        'service' : 'Service',
        'marketing' : 'Marketing',
        'legitimate' : 'Legitimate Interest'
      },
      smsTinyUrl: 'SMS Tiny URL',
      smsOffer: 'SMS Offer',
      startDate: 'Start Date',
      thumbPreviewUrl: 'Thumb Preview URL',
      touchpoint: 'CP Touchpoint',
      targetSource: {
        label: 'Target Source',
        contacts: 'Only Contacts',
        contacts_leads: 'Contacts + Leads / Permissions'
      },
      type: {
        label: 'Campaign Type',
        'Contact Plan': 'Contact Plan',
        VHR: 'VHR',
        'Commercial Campaign': 'Commercial Campaign'
      },
      updatePreview: 'Update Preview',
      validation: {
        startDateMustBeInFuture: 'Start Date must be in future'
      }
    },
    contentSelection: {
      addTemplate: 'Add Template',
      campaign: 'Campaign',
      contactMonth: {
        label: 'Contact Month',
        tooltip: 'To be filled with "Months Year" (example: November 2020)'
      },
      chLevel1: 'CH Level 1',
      chLevel2: 'CH Level 2',
      chLevel3: 'CH Level 3',
      chLevel4: 'CH Level 4',
      chOffer: 'CH Offer',
      contactPlanCampaign: 'Contact Plan Campaign',
      deleteTemplate: 'Delete template',
      formatId: {
        label: 'Format Id'
      },
      htmlImg: 'HTML Image',
      htmlTemplate: 'HTML Template',
      htmlTemplatePreview: 'HTML Template Preview',
      messageCustom: 'Custom Message',
      prefix: 'Prefix',
      sender: 'Sender',
      template: 'Template',
      templateId: 'Template Id',
      templateName: 'Template Name',
      templateType: {
        label: 'Template Type',
        F: 'FCA',
        T: 'Dealer'
      },
      updateTemplate: 'Update preview',
      validation: {
        email: {
          required: 'At least one template is required for this channel'
        }
      }
    },
    targetDefinition: {
      addEngagementCondition: 'Add Condition',
      addRule: 'Rule',
      addRuleGroup: 'Group',
      associatedDealer: 'Associated Dealer',
      applyToOtherSections: 'Apply to other offers',
      bookmarking: {
        bookmark: 'Bookmark',
        bookmarkName: 'Name'
      },
      channel: 'Channel',
      clear: 'Clear',
      brand: 'Brand',
      brandTypes: {
        label: 'Brand Types'
      },
      camper: 'Camper',
      carAge: 'Car Age',
      carFilterType: 'Car Filter Type',
      carsWithoutWarranties: 'Cars without warranties',
      clientType: {
        label: 'Client Type',
        P: 'Private',
        C: 'Company',
        U: 'Undefined'
      },
      communicationChannelsFilterLogic: {
        label: 'Communication Channels filter logic',
        AND: 'Match all criteria',
        OR: 'Match at least one'
      },
      communicationsNumber: {
        label: 'Number of communication in last days'
      },
      confirmFilterDisableTitle: 'Confirm element removal',
      confirmFilterDisableText: 'Element removed cannot be added back. Do you want to remove it?',
      contactPlan: 'Contact Plan',
      contentFilters: 'Content Filters',
      contracts: 'Contracts',
      contractsTooltip: 'Warranty Extension should be equal to Include or Exclude',
      cpTypeTargetSelection: 'CP-TYPE Target Selection',
      customerFilters: 'Customer Filters',
      dealerCluster: {
        label: 'Dealer Cluster',
        tooltip: 'Only those customer-vehicle for whom a dealer can be associated will be eligible'
      },
      deduplication: {
        label: 'Deduplication',
        deduplication: 'Select Deduplication Criteria',
        dedup_by_contact: 'Deduplicate by Contact',
        dedup_by_contact_and_lead: 'Deduplicate by Contact and Lead',
        sorting: 'Select Sorting Criteria',
        nearest: 'The VIN with the nearest First Reg. Date',
        oldest: 'The VIN with the oldest First Reg. Date',
        mostRecent: 'The VIN with the most recent Workshop Visit'
      },
      disableOrchestration: 'Disable Orchestration',
      downloadTemplate: 'Download template',
      elapsedTimeBetweenLastTwoVisits: {
        label: 'Workshop visit Elapsed Time',
        tooltip: 'Less than 30 days must have passed between the last visit and the previous'
      },
      eligibilityToConnectedServices: 'Connected services',
      eligibilityUConnectLive: 'UConnect Live',
      engagement: {
        label: 'Engagement',
        'RED': 'Disengaged (Red)',
        'GREEN': 'Engaged (Green)',
        'YELLOW': 'Alive (Yellow)',
        tooltip: `Engagement – How is engaged with the communications sent on a specific channel.
          The Engagement Index is applicable to all the customers and starts with the first communication sent to him/her.
          The nurturing communications do not contribute to the E.I. calculation.`
      },
      engagementIndex: 'Email Engagement Index',
      engineSize: 'Engine Size',
      excludeContactsWithoutAssociatedDealer: 'Exclude Contacts Without Associated Dealer',
      excludedMVS: 'Excluded MVS',
      excludedVIN: 'Excluded VIN ({count})',
      field: {
        'birthdate::date': 'Birthdate',
        'ccf_date::date': 'CCF Date',
        'd_opt_in_email_date::date': 'Email Opt-in Date',
        'first_reg_date::date': 'First Registration Date',
        'last_ocf_date_houseold::date': 'Last OCF Date Houseold',
        'last_ocf_date::date': 'Last OCF Date',
        'lead_date::date': 'Lead Date',
        'ocf_date::date': 'OCF Date',
        'perm_date::date': 'Permission Date',
        'purchase_date::date': 'Purchase Date',
        'quote_date::date': 'Quote Date',
        address: 'Address',
        brand: 'Brand',
        lp_brand: 'Brand',
        business_area: 'Business Area',
        city: 'City',
        class_interv: 'Interview class.',
        cod_market: 'Market',
        company_cat3: 'Company Cat 3',
        company_cat4: 'Company Cat 4',
        contact_plan_disabled: 'Contact Plan Disabled',
        control_group: 'Control Group',
        cta: 'CTA',
        customer_status_abarth: 'Customer Status Abarth',
        customer_status_alfa: 'Customer Status Alfa Romeo',
        customer_status_fiat: 'Customer Status FIAT',
        customer_status_fiatpro: 'Customer Status FIAT Pro',
        customer_status_jeep: 'Customer Status Jeep',
        customer_status_lancia: 'Customer Status Lancia',
        customer_status: 'Customer Status',
        d_opt_in_email: 'Email Opt-in',
        'data_intervista::date': 'Data Intervista',
        'data_ultimo_contatto::date': 'Data Ultimo Contatto',
        doubleOptIn: 'Double Opt In',
        email_service: 'Email service',
        email: 'Email address',
        fiat_employee: 'Fiat Employee',
        flag_camper: 'Flag Camper',
        flag_moc: 'Flag MOC',
        flag_owner: 'Flag Owner',
        flag_vat: 'Flag VAT',
        gender: 'Gender',
        has_car_total_fca: 'Has Car Total FCA',
        id_campaign: 'ID Campaign',
        id_offer: 'ID Offer',
        label: 'Attribute',
        level1: 'Level1',
        level2: 'Level2',
        level3: 'Level3',
        level4: 'Level4',
        lp_model: 'LP Model',
        markedAsHardBounceback: 'Marked as Hard Bounceback',
        market_segment: 'Market Segment',
        mobile_number_service: 'Mobile Number Service',
        mobile_number: 'Mobile Number',
        model: 'Model',
        mvs_external_id: 'MVS External Id',
        onlyDealerEmail: 'Only Dealer Email flag',
        outbound_abarth: 'Outbound Abarth',
        outbound_alfa: 'Outbound Alfa',
        outbound_fiat: 'Outbound FIAT',
        outbound_fiat_pro: 'Outbound FIAT Professional',
        outbound_jeep: 'Outbound JEEP',
        outbound_lancia: 'Outbound LANCIA',
        outbound_others: 'Outbound Others',
        outbound_total: 'Outbound Total',
        ownership_type: 'Ownership Type',
        party_type: 'Client Type',
        phone_number: 'Phone Number',
        pref_contact_code: 'Pref Contact Code',
        preferred_language: 'Preferred Language',
        privacy_email: 'Privacy Email',
        privacy_mail: 'Privacy Mail',
        privacy_tel: 'Privacy Phone',
        privacy_sms: 'Privacy SMS',
        province: 'Province',
        quote_brand: 'Brand',
        quote_mvs_external_id: 'Quote MVS External Id',
        record_validity: 'Record Validity',
        stato: 'Stato',
        uconnect_activation_flag: 'UConnect Activation Flag',
        zip_code: 'ZIP Code'
      },
      firstRegistrationDate: 'First Registration Date',
      fleet: {
        label: 'Fleet',
        tooltip: `This filter allows the user to include or exlude at coupons generation vehicles and customers that satisfy all the following conditions:
          1) Vehicles classified as Fleet
          2) Customers with Small or Medium Fleet Park
          3) Vehicles and Customers not LTR
          4) Vehicles sold as Indirect and Customer with only Indirect vehicles in park
          5) Customer not matched with a Customer on Salesforce
          6) Alfa Romeo Giulia Quadrifoglio vehicles will be excluded from the target (model 620, versions QRU and QRV)
          7) Only for France: customers with a Fleet park of 9 vehicles maximum (<10)
        `
      },
      freeMapUpdate: {
        label: 'Free Map Update',
        ELG: 'Eligible',
        EXP: 'Expired',
        ND: 'Not compatible or not verifiable'
      },
      fuelTypes: {
        label: 'Fuel Type',
        CMBBE: 'Electric / Gasoline',
        CMBBG: 'Gasoline / LPG',
        CMBBM: 'Gasoline / NCG',
        CMBBZ: 'Gasoline',
        CMBDS: 'Diesel',
        CMBEL: 'Electric',
        CMBMT: 'Methane',
        ELECTRIC: 'Electric',
        '00' : '00 : UNK',
        '01' : '01 : TER',
        '02' : '02 : TER',
        '03' : '03 : TER',
        '04' : '04 : TER',
        '05' : '05 : ELE',
        '06' : '06 : OTR',
        '07' : '07 : OTR',
        '08' : '08 : OTR',
        '09' : '09 : HYB',
        '10' : '10 : HYB',
        '11' : '11 : UNK',
        '12' : '12 : UNK',
        'AD' : 'AD : TER'
      },
      gender: {
        label: 'Gender',
        M: 'Male',
        F: 'Female'
      },
      includedMVS: 'Included MVS',
      includedVIN: 'Included VIN ({count})',
      lastUpdateDateIsLastWSVisit: {
        label: 'Updates from the last Workshop',
        tooltip: 'The last update date must correspond to the last workshop visit'
      },
      manageDealers: 'Manage Dealers',
      manageMVS: 'Manage MVS',
      manageVIN: 'Manage VIN',
      manageZipCodes: {
        label: 'Manage ZIP Codes',
        invalidZipCodesWarning: 'Warning: ZIP Codes not valid',
        invalidZipCodesWarningText: 'Following Markets - ZIP Codes are not valid: <ul>{list}</ul>'
      },
      market: {
        label: 'Market',
        ITA: 'Italy',
        FRA: 'France',
        USA: 'USA',
        JAP: 'Japan',
        ESP: 'Spain',
        CH: 'Switzerland'
      },
      marketingPrivacyConsent: 'Marketing Privacy Consent',
      vocation: 'Vocation',
      mileages: 'Mileage (km)',
      mileageTag: {
        label: 'Mileage Tag',
        H: 'High',
        M: 'Medium',
        L: 'Low'
      },
      maintenanceModelCluster: 'Vehicle Maintenance Model Cluster',
      manageMvsVin: 'Manage MVS / VIN',
      mapCare: {
        label: 'Map Care',
        ELG: 'Eligible',
        EXP: 'Expired',
        ND: 'Not compatible or not verifiable'
      },
      mapUpdate: {
        label: 'Map Update',
        ELG: 'Eligible',
        EXP: 'Expired',
        ND: 'Not compatible or not verifiable'
      },
      mileageTagAvailable: 'Mileage TAG Available',
      mmaAvailable: 'MMA available',
      modelYearFrom: 'Model Year From',
      monthsFromFirstRegistrationDate: 'Months from First registration date',
      moparConnect: {
        label: 'MOPAR Connect',
        ACC: 'Tested as an accessory',
        DIS: 'Disabled',
        ELG: 'Eligible',
        EXP: 'Expired',
        ND: 'Not compatible or not verifiable',
        OPT: 'Tested as an OPT',
        SOT: 'Subscribed'
      },
      mvs: 'MVS',
      mvsNotFoundWarning: 'Warning: MVS not found',
      mvsNotFoundWarningText: 'Following MVS have not been found: <ul>{list}</ul>',
      ocfDate: 'OCF Date',
      pressure: {
        label: 'Pressure',
        P1: '1 - 2 contacts (P1)',
        P2: '3 - 6 contacts (P2)',
        P3: '7 - 12 contacts (P3)',
        P4: '13 - 24 contacts (P4)',
        P5: '> 24 contacts (P5)'
      },
      preview: 'Filter Definition Preview',
      profilingPrivacyConsent: 'Profiling Privacy Consent',
      purchasedServicesAndAccessories: 'Purchased services and accessories',
      rangeSelector: 'Range Selector',
      reactivity: {
        label: 'Reactivity',
        R0: 'No open (R0)',
        R1: '0 - 3 days (R1)',
        R2: '4 - 10 days (R2)',
        R3: '> 10 days (R3)',
        tooltip: `Average time taken by the customer for interacting (e.g. opening, clicking) with the communications received.
          The Index is calculated on a specific number of communications received: from 1 up to 5.`
      },
      registrationOnMOC: 'Registration on MOC',
      ruleGroup: 'Group',
      rulesAlert: 'Rules about Brand, Market, Privacy and Channels have already been imported from Campaign Setup',
      saveGroupAs: 'Save Group as ...',
      saveSectionAs: 'Save Filter Definition as ...',
      selectBrands: 'Select at least one brand to select MVS',
      status: 'Status',
      segment: 'Segment',
      segmentName: 'Section name',
      segments: 'Filter Definition',
      deletePreview: 'Delete Preview',
      deletePreviewConfirm: 'Are you sure you want to delete this preview?',
      standardSegment: 'From Campaign Setup',
      table: {
        label: 'Entity',
        car: 'Car',
        contact: 'Contact',
        lead: 'Lead',
        perm: 'Permission',
        ocf: 'OCF',
        quote: 'Quote'
      },
      targetCluster: {
        label: 'Target Cluster',
        'at risk': 'At Risk',
        beginner: 'Beginner',
        loyal: 'Loyal',
        lost: 'Lost'
      },
      targetRange: {
        label: 'Target Range'
      },
      tbm: 'TBM',
      tbmMoparConnect: 'TBM / MOPAR Connect',
      touchpointSelection: 'Touchpoint Selection',
      uploadCsv: 'Upload CSV',
      uploadVINToExclude: 'Upload VIN to exclude',
      validation: {
        missingOperator: 'Please specify a match condition',
        missingRuleOrGroup: 'A rule or rule group is required',
        oneConditionRequired: 'For this match condition only one rule is required',
        twoOrMoreConditionsRequired: 'For this match condition at least two rules are required'
      },
      values: 'Values',
      vehicleTypes: {
        label: 'Vehicle Type',
        CABRIO: 'Cabrio',
        CITYCAR: 'City car',
        ECO: 'Eco',
        HYBRID: 'Hybrid',
        SUV: 'SUV'
      },
      viewMVS: 'View MVS',
      viewVIN: 'View VIN',
      vin: 'VIN',
      warrantyExtension: 'Warranty Extension',
      workshopVisitsWithSameMileageTagNumber: {
        label: 'Associated Mileage tag confirmed',
        tooltip: 'The customer must have performed two or more workshop visits in which the same mileage tags were associated'
      },
      zipCode: 'ZIP Code'
    },
    contentSelectionAndTag: {
      brand: 'Brand',
      carAge: 'Car Age',
      camper: 'Camper',
      churnScore: 'Churn Score',
      contentPriority: {
        label: 'Priority*',
        primary: 'Primary',
        secondary: 'Secondary',
        tertiary: 'Tertiary'
      },
      contentSetting: 'Content Setting',
      date: 'Date',
      description: 'Description*',
      downloadCsv: 'Download as CSV',
      endDate: 'End Date',
      excludeVin: 'Excluded VIN ({count})',
      flatOffer: 'Offer',
      fleet: 'Fleet',
      includeVin: 'Included VIN ({count})',
      insertNewContent: 'Insert new content',
      itemTypeDescription: 'Item',
      itemDescription: 'Item Description',
      kmFrom: 'Km From',
      kmTo: 'Km To',
      masterKey: 'MasterKey',
      monthAge: 'Model Age',
      mvsList: 'MVS List',
      mvs: 'MVS',
      mvsTabLabel: 'MVS ({count})',
      name: 'Offer Type',
      offerType: 'Offer Type',
      onlyInformativeCampaign: 'Only informative campaign',
      quantity: 'Quantity',
      offer: 'Offer',
      offerSelection: 'Offer Selection',
      priceValue: 'Value',
      startDate: 'Start Date',
      status: 'Status',
      tag: 'Tag*',
      touchPoint: 'TouchPoint',
      validate: {
        insertContent: 'For this campaign type at least one content is required',
        insertOffer: 'For this campaign type at least one offer is required'
      },
      vinList: 'VIN List',
      vinMvsList: 'VIN / MVS List',
      vin: 'VIN'
    },
    finalCheckAndCampaignRelease: {
      brand: 'Brand',
      channel: 'Channel',
      channelPriority: 'Channels Priority',
      computePreview: 'Compute Preview',
      computingPreview: 'Computing Preview...',
      contactCount: 'Contact Count',
      emptyPreview: 'No contact has been extracted from the preview',
      numberOfContacts: '# Contacts',
      numberOfContactsEmailGranted: '# Contacts Email Granted',
      numberOfContactsSmsGranted: '# Contacts SMS Granted',
      numberOfCars: '# Cars',
      numberOfDistinctEmail: '# Distinct Email',
      numberOfDistinctSMS: '# Distinct SMS',
      leadType: {
        label: 'Lead Type',
        lead: 'Lead',
        perm: 'Permission'
      },
      previewError: 'An error occured while computing preview',
      status: 'Status'
    },
    confirmActivation: {
      as_app_delivery: {
        title: 'App Delivery Campaign activation',
        text: 'By activating this campaign every other App Delivery campaign will be disabled. Do you want to continue?'
      },
      as_rfid: {
        title: 'RFID Campaign activation',
        text: 'By activating this campaign every other RFID campaign will be disabled. Do you want to continue?'
      },
      vhr: {
        title: 'VHR Campaign activation',
        text: 'By activating this campaign every other VHR campaign will be disabled. Do you want to continue?'
      },
      sr_app_delivery: {
        title: 'App Delivery Campaign activation',
        text: 'By activating this campaign every other App Delivery campaign will be disabled. Do you want to continue?'
      },
      sr_rfid: {
        title: 'RFID Campaign activation',
        text: 'By activating this campaign every other RFID campaign will be disabled. Do you want to continue?'
      },
      standard: {
        title: 'Campaign activation',
        text: 'Once activated, the current campaign will be immediately orchestrated. Do you want to continue?'
      }
    },
    confirmPageLeaveText: 'There are unsaved changes that will be lost. Do you want to continue?',
    createCampaign: 'Create Campaign',
    editCampaign: 'Edit Campaign',
    viewCampaign: 'View Campaign',
    newCampaign: 'New Campaign'
  },
  domainTablesConfiguration: {
    title: 'Domain Tables Configuration',
    rows: 'Rows'
  },
  executionRules: {
    exclusionRules: {
      calendar: {
        label: 'Calendar',
        CC: 'Commercial Campaign',
        VHR: 'VHR'
      },
      country: 'Country',
      market: 'Market',
      selectCalendar: 'Select a Calendar',
      selectMarketOrCountry: 'Select a Market/Country',
      today: 'Today',
      viewMode: {
        daily: 'Daily',
        monthly: 'Monthly',
        weekly: 'Weekly',
        yearly: 'Yearly'
      }
    },
    sendingRules: {
      calendar: {
        label: 'Calendar',
        CC: 'Commercial Campaign',
        VHR: 'VHR'
      },
      channel: 'Channel',
      market: 'Market',
      maxCommsMonth: 'Max communications per month',
      maxCommsWeek: 'Max communications per week',
      minDaysBetweenComms: 'Min days between communications',
      selectMarketAndChannel: 'Select a Market/Country and a Channel',
      modal: {
        addSlot: 'Add Slot',
        editSlot: 'Edit Slot',
        inclusionDay: 'Inclusion Day',
        sendStartHour: 'Start Hour',
        sendEndHour: 'End Hour'
      }
    }
  },
  fastCounter: {
    createPreview: 'Create Preview',
    editPreview: 'Edit Preview',
    viewPreview: 'View Preview',
    newPreview: 'New Preview',
    previewList: {
      previewList: 'Preview',
      filters: 'Filters',
      showPreview : 'Show Preview Results',
      previewNotAvailable: 'Preview results not available',
      previewError: 'Error trying to retrieve the preview results'
    },
    finalCheck: {
      abarth: 'Abarth',
      alfa: 'Alfa Romeo',
      brand: 'Brand',
      count: 'Count',
      customer: 'Customer',
      fiat: 'FIAT',
      fiatPro: 'FIAT Professional',
      jeep: 'JEEP',
      lancia: 'Lancia',
      oldCustomer: 'Old Customer',
      privacyEmailF: 'Privacy Email F',
      privacyEmailG: 'Privacy Email G',
      privacySmsF: 'Privacy SMS F',
      privacySmsG: 'Privacy SMS G',
      prospect: 'Prospect',
      year: 'Year'
    },
    previewSetup: {
      previewName: 'Name',
      market: 'Market',
      channel: 'Channel',
      brand: 'Brand'
    },
    targetDefinition: {
      bookmarkCreatedBy: 'Created by {user} on {date}',
      rulesAlert: 'Rules about Markets have already been imported from Preview Setup',
      filterBookmarks: 'Filter bookmarks',
      filterPreviews: 'Filter previews'
    }
  },
  jobsViewer: {
    title: 'Jobs'
  },
  usersManagement: {
    editUser: 'Edit User information',
    users: 'Users',
    filters: {
      active: {
        'true': 'Active',
        'false': 'Inactive'
      },
      status: {
        all: 'All',
        label: 'Status'
      }
    },
    user: {
      active: 'Active',
      countries: 'Countries',
      brands: 'Brands',
      email: 'Email',
      name: 'Full Name',
      role: 'Role',
      role_tooltip: 'Viewer: Can only view campaigns and exclusion rules | Channel Manager: Can create, edit exclusion rules and campaigns and also view offers. | Administrator: All of the above + user management settings',
      roles: {
        ADMINISTRATOR: 'Administrator',
        CHANNEL_MANAGER: 'Channel Manager',
        CONTENT_EDITOR_PUBLISHER: 'Content Editor / Publisher',
        SECURITY_ADMINISTRATOR: 'Security Administrator',
        VIEWER: 'Viewer'
      },
      visibility: 'Visibility',
      visibility_tooltip: 'CAMPAIGN_STELLANTIS allows users to create Stellantis (Full, Only Header) campaigns, \
                      CAMPAIGN_TECHNICAL allows users to create Technical (and VHR) campaigns',
    }
  },
  sections: {
    navigation: 'Navigation',
    administration: 'Administration',
    campaignDesigner: 'Campaign Designer',
    campaignMonitoring: 'Campaign Monitoring',
    contentSelection: 'Content Selection',
    customization: 'Customization',
    domainTablesConfiguration: 'Domain Tables Configuration',
    userManagement: 'User Management',
    executionRules: {
      label: 'Execution Rules',
      exclusionRules: {
        label: 'Exclusion Rules'
      },
      sendingRules: {
        label: 'Sending Rules'
      }
    },
    campaignSetup: 'Campaign Setup',
    targetDefinition: 'Target Definition',
    contentSelectionAndTag: 'Content Selection & Tag',
    finalCheckAndCampaignRelease: 'Final Check & Campaign Release',
    settings: 'Settings',
    home: 'Home',
    cleanIt: 'Clean IT',
    offerViewer: 'Offer Viewer',
    fastCounter: 'Fast Counter',
    previewSetup: 'Preview Setup',
    preview: 'Preview'
  },
  locales: {
    de: 'German',
    es: 'Spanish',
    fr: 'French',
    gb: 'English',
    it: 'Italian'
  },
  setting: {
    locale: 'Locale'
  },
  validation: {
    biggerOrEqualThan: 'Value must not be lower than minimum value ({minValue})',
    custom: {
      addAtLeastOneBrand: 'At least one brand / model is required for this campaign type',
      atLeastOneFilterIsRequired: 'Set either Engagement conditions or Months from First Registration date',
      noBrands:'At least one brand is required if the user is active',
      conditionalRequiredUserManagement: 'At least one country is required if the user is active',
      contentAlreadyPresent: 'Content already present with same description and tags',
      ddsAcceptanceDateBeforeStartDate: 'Acceptance Expiring Date must be before Start Date',
      endDateExceed: 'End Date cannot be after offer\'s End Date',
      invalidZipCodeForMarket: 'Zip Code is invalid for this market',
      startDateExceed: 'Start Date cannot be before offer\'s Start Date'
    },
    dateAfter: 'Invalid date',
    dateAfterToday: 'Invalid date: date must be in future',
    dateBefore: 'Start date must be before End date',
    duplicateRange: 'Duplicate range',
    duplicateValue: 'Value already present',
    email: 'Invalid format',
    hour: 'Invalid format',
    hourBefore: 'Start time must be before End time',
    invalidData: 'Error: invalid data',
    invalidDataMessage: 'Review all message below to correct your data',
    isInRange: 'Values must not exceed the offers one',
    lessOrEqualThan: 'Value must not exceed maximum value ({maxValue})',
    maxLength: 'Text length must not exceed maximum value ({maxValue})',
    positiveNumber: 'Invalid format',
    required: 'Required field',
    rangeMismatch: '"From" must be lower than "to"',
    url: 'Invalid format',
    year: 'Invalid year format'
  },
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  days: {
    eng: {
      short: {
        MON: 'Mon',
        TUE: 'Tue',
        WED: 'Wed',
        THU: 'Thu',
        FRI: 'Fri',
        SAT: 'Sat',
        SUN: 'Sun'
      },
      long: {
        MON: 'Monday',
        TUE: 'Tuesday',
        WED: 'Wednesday',
        THU: 'Thursday',
        FRI: 'Friday',
        SAT: 'Saturday',
        SUN: 'Sunday'
      }
    },
    short: [
      'Sun',
      'Mon',
      'Tue',
      'Wed',
      'Thu',
      'Fri',
      'Sat'
    ],
    long: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ]
  },
  brands: {
    All: 'Multibrand',
    fiat: 'FIAT',
    abarth: 'Abarth',
    lancia: 'LANCIA',
    '057': 'JEEP',
    '000': 'FIAT',
    '070': 'LANCIA',
    '066': 'ABARTH',
    '083': 'ALFA ROMEO',
    '077': 'FIAT PROFESSIONAL',
    '090': 'CITROEN',
    '091': 'DS',
    '092': 'OPEL',
    '093': 'PEUGEOT',
    '094': 'VAUXHALL',
    '095': 'SPOTICAR',
    'AH': 'ABARTH',
    'AR': 'ALFA_ROMEO',
    'AC': 'CITROEN',
    'FT': 'FIAT',
    'FO': 'FIAT PROFESSIONAL',
    'JE': 'JEEP',
    'LA': 'LANCIA',
    'OP': 'OPEL',
    'AP': 'PEUGEOT',
    'SP': 'SPOTICAR',
    'VX': 'VAUXHALL',
    'DS': 'DS',
  },
  channels: {
    push: 'Push',
    call: 'Call',
    cross: 'Cross',
    document: 'Paper',
    email: 'Email',
    sms: 'SMS'
  },
  consent: {
    'Y': 'Yes',
    'N': 'No',
    'noFilter': 'No Filter'
  },
  countries: {
    DEU: 'Deutschland',
    ESP: 'Spain',
    FRA: 'France',
    ITA: 'Italy',
    USA: 'United States'
  },
  markets: {
    '1000': 'Italy',
    '1001': 'Algeria',
    '1002': 'Argentina',
    '1003': 'Chile',
    '1004': 'Japan',
    '1005': 'Luxembourg',
    '3103': 'Austria',
    '3104': 'Belgium',
    '3105': 'Bulgaria',
    '3107': 'Denmark',
    '3109': 'France',
    '3110': 'Germany',
    '3112': 'United Kingdom',
    '3114': 'Ireland',
    '3122': 'Netherlands',
    '3123': 'Poland',
    '3128': 'Switzerland',
    '3136': 'Spain',
    '3106': 'Czech Republic',
    '3113': 'Greece',
    '3124': 'Portugal',
    '3127': 'Sweden',
    '3129': 'Hungary',
    '3175': 'Romania',
    '3211': 'Cyprus',
    '3239': 'Turkey',
    '3488': 'Malta',
    '3544': 'Estonia',
    '3545': 'Lithuania',
    '3546': 'Latvia',
    '3547': 'Slovenia',
    '3548': 'Croatia',
    '3564': 'Slovakia',
    '3606': 'Serbia',
    '3608': 'Finland',
    '3671': 'Norway'
  },
  filters: {
    exclude: 'Exclude',
    include: 'Include',
    noFilter: 'No filter',
    carAge: {
      touchpoint: 'Touchpoint',
      date: 'Date',
      age: 'Age'
    }
  },
  churnScore: {
    'at risk': 'At Risk',
    beginner: 'Beginner',
    lost: 'Lost',
    loyal: 'Loyal',
    'null': 'N/A',
    'AT RISK': 'At Risk',
    BEGINNER: 'Beginner',
    LOST: 'Lost',
    LOYAL: 'Loyal',
    'NULL': 'N/A'
  },
  notification: {
    DDS_CAMPAIGN_SYNC: {
      title: 'DDS Campaigns sync',
      text: 'DDS Campaigns information started successfully'
    },
    PREVIEW_COMPUTED: {
      title: '{campaignId} - Preview generation ended',
      text: 'Preview for campaign {campaignId} has been generated!'
    },
    PREVIEW_ERROR: {
      title: '{campaignId} - Preview generation ended',
      text: 'Preview generation for campaign {campaignId} ended with an error'
    },
    TARGET_COMPUTED: {
      title: '{campaignId} - Target generation ended',
      text: 'Target for campaign {campaignId} has been generated!'
    },
    TARGET_ERROR: {
      title: '{campaignId} - Target generation ended',
      text: 'Target generation for campaign {campaignId} ended with an error'
    },
    SEED_TARGET_COMPUTED: {
      title: '{campaignId} - Seed Target generation ended',
      text: 'Seed Target for campaign {campaignId} has been generated!'
    },
    SEED_TARGET_ERROR: {
      title: '{campaignId} - Seed Target generation ended',
      text: 'Seed Target generation for campaign {campaignId} ended with an error'
    }
  },
  departments: {
    AFTER_SALES: 'After Sales',
    SALES: 'Sales'
  },
  country: {
    AT: 'Austria',
    BE: 'Belgium',
    BG: 'Bulgaria',
    CH: 'Switzerland',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DE: 'Germany',
    DK: 'Denmark',
    EE: 'Estonia',
    ES: 'Spain',
    FI: 'Finland',
    FR: 'France',
    GR: 'Greece',
    HR: 'Croatia',
    HU: 'Hungary',
    IE: 'Ireland',
    IS: 'Iceland',
    IT: 'Italy',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    LV: 'Latvia',
    MT: 'Malta',
    NL: 'Netherlands',
    NO: 'Norway',
    PL: 'Poland',
    PT: 'Portugal',
    RO: 'Romania',
    RS: 'Serbia',
    SE: 'Sweden',
    SI: 'Slovenia',
    SK: 'Slovakia',
    TR: 'Turkey',
    UK: 'United Kingdom',
    DZ: 'Algeria',
    AR: 'Argentina',
    CL: 'Chile',
    JP: 'Japan',
    GB: 'United Kingdom'
  },
  operator: {
    AND: 'AND',
    OR: 'OR',
    and: 'and',
    or: 'or'
  },
  operators: {
    eq: 'Is',
    gte: 'Is after / greater than',
    in: 'Is one of',
    isnull: 'Is blank',
    isnotnull: 'Is not blank',
    lte: 'Is before / less than',
    ne: 'Is not',
    notin: 'Is not one of',
    AND: 'Match all conditions (AND)',
    OR: 'Match at least one condition (OR)',
    NOT: 'Does not match condition (NOT)'
  },
  queryBuilder: {
    bookmarks: 'Bookmarks',
    deleteBookmark: {
      title: 'Delete Bookmark',
      message: 'Are you sure you want to delete this bookmark?'
    },
    dropHereToAdd: 'Drop here to add',
    import: 'Import',
    delete: 'Delete',
    noBookmark: 'No bookmark found on the system',
    fullSentence: {
      exclude: 'Exclude <strong>{entity}</strong> whose <strong>{attribute}</strong> {operator} <strong>{value}</strong>',
      excludeWithGroupOperator: 'Exclude <strong>{entity}</strong> whose <strong>{attribute}</strong> {operator} <strong>{value}</strong>, {groupOperator}',
      include: '<strong>{entity}</strong> whose <strong>{attribute}</strong> {operator} <strong>{value}</strong>',
      includeWithGroupOperator: '<strong>{entity}</strong> whose <strong>{attribute}</strong> {operator} <strong>{value}</strong>, {groupOperator}'
    },
    noValueSentence: {
      exclude: 'Exclude <strong>{entity}</strong> whose <strong>{attribute}</strong> {operator}',
      excludeWithGroupOperator: 'Exclude <strong>{entity}</strong> whose <strong>{attribute}</strong> {operator}, {groupOperator}',
      include: '<strong>{entity}</strong> whose <strong>{attribute}</strong> {operator}',
      includeWithGroupOperator: '<strong>{entity}</strong> whose <strong>{attribute}</strong> {operator}, {groupOperator}'
    },
    eq: 'is equal to',
    gte: 'is after / bigger than',
    lte: 'is before / less than',
    ne: 'is different from',
    in: 'is one of',
    isnull: 'is blank',
    isnotnull: 'is not blank',
    notin: 'is not one of'
  },
  leadType: {
    lead: 'Lead',
    permission: 'Permission'
  },
  privacy: {
    G: 'Grant',
    F: 'Forbidden',
    U: 'Unknown'
  }
}
